import type { FilterConfig, FilterRegistry } from './types';

/**
 * PD-17437 — the Teams filter on the main lists, as the same tree the
 * reports use (rendered by BaseTeamTreeSelect for any filter reading the
 * team options). Each list's filter follows that list's own meaning of
 * "salesperson"; the SQL is in the team handler of typeormFilterBuilder
 * (and in the task service for Tasks). A pick includes its sub-teams unless
 * sent as "=<id>".
 */
const teamTreeFilter = (queryParamName: string, objectTable: string, listKeys: Array<string>): FilterConfig => ({
	type: 'multi-select',
	label: 'Teams',
	placeholder: 'All teams',
	colorScheme: 'blue',
	searchable: true,
	loadOnFocus: true,
	displayFields: {
		id: 'team_id' as keyof unknown,
		primary: 'team_name' as keyof unknown,
	},
	// The report endpoint offers each reader the teams they may pick: all of
	// them with access to all data, otherwise the teams they manage and
	// beneath; none at all hides the filter.
	apiEndpoint: '/reporting/team-options',
	queryParamName,
	multiple: true,
	format: 'array',
	valueExtractor: { property: 'id' },
	queryMapping: { objectTable, joinType: 'custom' },
	listKeys,
});

export const teamListFilters: FilterRegistry = {
	// The customer's rep is on the team.
	clientTeams: teamTreeFilter('clientTeams', 'client', ['client']),
	// The customer's rep (primary or alternate) is on the team, as Client Sales Rep.
	orderTeams: teamTreeFilter('orderTeams', 'order', ['order']),
	quoteTeams: teamTreeFilter('quoteTeams', 'order', ['quote']),
	// The invoice's own rep or its customer's rep is on the team, as Invoice Sales Rep.
	invoiceTeams: teamTreeFilter('invoiceTeams', 'invoice', ['invoice']),
	// The person the opportunity is assigned to is on the team.
	opportunityTeams: teamTreeFilter('opportunityTeams', 'opportunity', ['opportunity']),
	// The person the task is assigned to is on the team.
	taskTeams: teamTreeFilter('taskTeams', 'task', ['task']),
};
